/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/findIndex */
import{operate as n}from"rxjs/dist/esm/internal/util/lift";import{createFind as o}from"rxjs/dist/esm/internal/operators/find";function d(r,e){return n(o(r,e,"index"))}export{d as findIndex};
//# sourceMappingURL=findIndex.mjs.map